export const couplingValues = {
  s: 0,
  d: 1,
  t: 2,
  q: 3,
  quint: 4,
  h: 5,
  hex: 5,
  hept: 6,
  sept: 6,
  oct: 7,
  o: 7,
  non: 8,
  n: 8,
};
